import React from 'react';
import './style.scss';

const RequiredField = React.memo(({valid, style}) =>
  !valid ? <div style={{top: style}} className="fa fa-exclamation-circle input-group-addon required-field-icon"></div> : <div></div>
);

export default RequiredField;
